module.exports = __webpack_public_path__ + "static/media/building.5cba9fa7.svg";